import React from 'react'
import * as h from '../../helpers/helpers';
import { lu } from '../../data/reportData';
import { TAB, CK, TABLE, H1, H2, TX_B, TXC, TXC_B, TXR_B, TXR_I, TXR_II } from "../../styles/urar-styles";
import { COMMENTARY, EXHIBITS } from "../../styles/urar-styles";

export function MANUFACTURED_HOME({dwelling}) {

	var mh = global.ptr.subDwelling.manufacturedHome;
	if ( mh === null) return undefined;

	return (
		<>
			<TAB title="Manufactured Home" />
			<div className='col2 mt-3'>
				<div>
					<TXR_B title="Manufacturer Name" value={lu("9.000")} />
					<TXR_B title="Year Installed" value={lu("9.001")} />
					<TXR_B title="Moved Since Original Installation" value={lu("9.002")} />
				</div>
				<div>
					<TXR_B title={"Attached to Permanent\nFoundation"} value={lu("9.003")} />
					<TXR_B title={"Towing Hitch, Wheels, Axles\nRemoved"} value={lu("9.004")} />
					<TXR_B title="Manufactured Home Width" value={lu("9.005")} />
					<TXR_B title="Skirting" value={lu("9.006")} />
				</div>
			</div>

			<CK title="Have there been any modifications, attachments, or additions that rely on or have altered the original structure for support?" value={lu("9.007")} space yn />
			<TXR_B title="Modification, Attachment, or Addition" value={lu("9.008")} space />
			<TXC_B title="Description of Modification, Attachment, or Addition" value={lu("9.009")} />

			<H1 title="HUD Data Plate" />
			<div className='col2 mt-3'>
				<div>
					<TXR_B title="HUD Data Plate Attached" value={lu("9.010")} />
					<TXR_B title="Date of Manufacture" value={lu("9.011")} />
					<TXR_B title="Serial Number" value={lu("9.012")} />
				</div>
				<div>
					<TXR_B title="HUD Wind Zone" value={lu("9.013")} />
					<TXR_B title="HUD Thermal Zone" value={lu("9.014")} />
					<TXR_B title="HUD Roof Load Zone" value={lu("9.015")} />
				</div>
			</div>

			<H1 title="HUD Certification Label" />
			<div className='col2 mt-3'>
				<div>
					<TXR_B title="Label Present for All Sections" value={lu("9.016")} />
				</div>
				<div>
					<TXR_B title="HUD Certification Number" value={lu("9.017")} />
				</div>
			</div>

			{ mh.manufacturedHomeFinancingPrograms.length > 0 &&
			<>
				<H1 title="Manufactured Home Certification Program" />
				<div className='col2 mt-3'>
					<div>
						<TABLE titles={["Certification","Identifier"]} widths={[264,264]} values={lu("9.018-19")} />
					</div>
					<div>
					</div>
				</div>
				</>
			}

			{ global.ptr.subDetail.newConstructionIndicator &&
			<>
				<H1 title="Invoice Information" />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Purchased from Retailer" value={lu("9.020")} />
						<TXR_B title="Retailer Name" value={lu("9.021")} />
					</div>
					<div>
						<TXR_B title="Retailer’s Invoice Reviewed" value={lu("9.022")} />
						<TXR_B title="Manufacturer’s Invoice Reviewed" value={lu("9.023")} />
						<TXR_B title="Invoice(s) Appear Reasonable" value={lu("9.024")} />
					</div>
				</div>
				<TXC_B title="Commentary on Why Invoice(s) Not Reasonable" value={lu("9.025")} />
			</>
			}

			<COMMENTARY title="Manufactured Home Commentary" value={lu("9.026")} />

			<EXHIBITS title="Manufactured Home Exhibits" id={["ManufacturedHomeHUDDataPlate"]} />
		</>
	)
}
